import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as Globals from '../../globals';
import { Observable, of } from 'rxjs';

import { tap, switchMap } from 'rxjs/operators';
import { LocalStorage } from '@ngx-pwa/local-storage';

import { PayloadService } from '../payload/payload.service';

@Injectable({
    providedIn: 'root'
})
export class UserService {

    configUrl = Globals.url_api;

    constructor(
        private http: HttpClient,
        public localStorage: LocalStorage,
        public payloadService: PayloadService
    ) { }

    init(payload: string): Observable<any> {
        return this.http.post(this.configUrl + "users/init", { "payload": payload });
    }


    listUsersCrm(): Observable<any> {
        return this.payloadService.getPayload().pipe(
            switchMap(
                (payload) =>{
                    return this.http.post(this.configUrl + "users/listcrm", { "payload": payload })
                }
            )
        )
        
    }

    list(): Observable<any> {
        return this.payloadService.getPayload().pipe(
            switchMap(
                (payload) =>{
                    return this.http.post(Globals.url_api + "recharges/list", {
                        "payload": payload
                    });
                }
            )
        )
    }


}
